import React, { Component } from "react";
import { renderLogicUtil } from "views/Pma/RenderLogicUtil";
import "./print.scss";

class QRCode extends Component {
  render() {
    const { isHomeownerAbsentie } = renderLogicUtil;

    let { smallerQR, currentArea, printVersion, moveQRAndTableDown } =
      this.props;
    const { mlsAreaID } = currentArea || {};
    const { listgenUserID, listgenUserFirstName, listgenUserLastName } =
      this.props.agentData;
    let { homeOwnerURLID, homeOwnerURLQRCodePath, homeOwnerURL } =
      this.props.hoData;

    const bypassMailingCityCheck =
      this.props.agentData &&
      (listgenUserID === "100458" ||
        listgenUserID === "100526" ||
        listgenUserID === "100902");

    let isAbsenteeHO = false;
    if (this.props.hoData) {
      const ho = this.props.hoData;
      if (
        ho.HOQuickFilterData &&
        typeof ho.HOQuickFilterData.isAbsentee === "boolean"
      ) {
        isAbsenteeHO = ho.HOQuickFilterData.isAbsentee;
      } else if (ho.mailingDetails) {
        isAbsenteeHO = isHomeownerAbsentie(ho, bypassMailingCityCheck);
      }
    }

    const isAbsenteeSBCondos =
      listgenUserID === "109989" &&
      mlsAreaID === "SBA-20FCondo" &&
      isAbsenteeHO;

    if (listgenUserID === "101") {
      homeOwnerURL = "https://ourproperty.info/c12p";
      homeOwnerURLID = "c12p";
      homeOwnerURLQRCodePath =
        "https://lg-qr-code-images.s3.amazonaws.com/c12p.png";
    }
    if (
      listgenUserFirstName === "Sarah" &&
      listgenUserLastName === "Sullivan"
    ) {
      homeOwnerURL = "https://ourproperty.info/12345";
      homeOwnerURLID = "12345";
      homeOwnerURLQRCodePath =
        "https://d2onbxnrte2nim.cloudfront.net/non-covers/12345.png";
    }
    let largerQRCode = false;
    if (listgenUserID === "100030") {
      largerQRCode = true;
    }
    //updating global note
    let lowerQRCodeStyles;
    if (mlsAreaID === "xCCA-4400QA") {
      lowerQRCodeStyles = "top-370-qr-section";
    } else if (moveQRAndTableDown) {
      lowerQRCodeStyles = "top-353-qr-section";
    }
    // = "top-305-qr-section";
    // if (listgenUserID === "x105642" || listgenUserID === "x104835") {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // } else if (
    //   currentArea &&
    //   currentArea.globalNoteCurrent &&
    //   currentArea.globalNoteCurrent.length > 600
    // ) {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // }
    // if (listgenUserID === "105805" || listgenUserID === "106024") {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // } else if (listgenUserID === "105794" || listgenUserID === "106652") {
    //   lowerQRCodeStyles = "qr-code-top-345";
    // } else if (
    //   listgenUserID === "104835" ||
    //   listgenUserID === "107019" ||
    //   listgenUserID === "105790"
    // ) {
    //   lowerQRCodeStyles = "lower-qr-code-2";
    // }
    let qrDescription = "Scan Here for a Complimentary Home Valuation";
    let editedQRDescription = false;
    if (listgenUserID === "108287" || listgenUserID === "108341") {
      editedQRDescription = true;
      qrDescription = "Are you thinking of selling? Scan here";
    }

    // printVersion is forced true in PMAEditor even on /pma, so do not use !printVersion.
    const isPmaEditor = window.location.href.includes("/pma");
    const qrHref = (href, inner) =>
      isPmaEditor ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {inner}
        </a>
      ) : (
        inner
      );

    if (listgenUserID === "x100411") {
      return "";
    } else {
      return (
        <div
          className={`${
            printVersion
              ? "print-qr-code-section-v2"
              : "editor-qr-code-section-v2"
          } ${smallerQR && "smaller-qr-section-v2"} ${lowerQRCodeStyles}`}
        >
          <div className="qr-code-col1">
            <div
              className={`bubble-arrow-container ${
                smallerQR && "smaller-qr-arrow-img"
              } ${largerQRCode && "larger-qr-arrow-img"}`}
            >
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/091826__DoubleArrow-multi.png"
                alt="Double Arrow April 2"
              />
            </div>
          </div>
          <div className="qr-code-col2">
            <div className="qr-code-content-row">
              <div
                className={`bubble-qr-container ${
                  smallerQR && "smaller-qr-img"
                } ${largerQRCode && "larger-qr-img"}`}
              >
                {listgenUserID === "101566" ? (
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/gummow-bros-qr-cropped.png"
                    className="bubble-qr-image auto-width-qr"
                    alt="Gummow brothers QR code"
                  />
                ) : listgenUserID === "100411" ? (
                  <img
                    src="https://d2onbxnrte2nim.cloudfront.net/040323_Garret-MC_QRcode_500px.jpg"
                    className="bubble-qr-image"
                    alt="Garrett QR Code"
                  />
                ) : (
                  <img
                    src={homeOwnerURLQRCodePath}
                    className="bubble-qr-image"
                    alt="QR Code"
                  />
                )}
              </div>
              <div className="qr-code-text">
                {editedQRDescription ? (
                  <p>
                    {qrDescription}
                    <br />
                    {qrHref(
                      homeOwnerURL,
                      <span className="qr-code-link">
                        OurProperty.info/{homeOwnerURLID}
                      </span>,
                    )}
                  </p>
                ) : isAbsenteeSBCondos ? (
                  <p>
                    Scan the QR code to learn more about the state of Santa
                    <br /> Barbara rent stabilization as reported by The
                    Independent
                  </p>
                ) : listgenUserID === "106531" ? (
                  <p>
                    Curious what your home is worth?
                    <br /> Scan the QR code to find out!
                    {qrHref(
                      homeOwnerURL,
                      <span className="qr-code-link">
                        OurProperty.info/{homeOwnerURLID}
                      </span>,
                    )}
                  </p>
                ) : listgenUserID === "100030" ? (
                  <p>
                    Your Complimentary Home Valuation:
                    <br /> Simply scan the QR code or go to
                    {qrHref(
                      "https://www.randallrealty.com/valuation-form/",
                      <span className="qr-code-link">
                        randallrealty.com/valuation-form
                      </span>,
                    )}
                  </p>
                ) : listgenUserID === "101566" ? (
                  <p className="qr-text-neg-mar-17">
                    Your Complimentary Home Valuation:
                    <br /> Simply scan the QR code or go to
                    {qrHref(
                      homeOwnerURL,
                      <span className="qr-code-link">
                        www.gummowbrothers.com/home-valuation
                      </span>,
                    )}
                  </p>
                ) : listgenUserID === "100411" ? (
                  <p>
                    Do you know what your home is worth? Simply scan the QR code
                    to the left or go to
                    {qrHref(
                      "https://hmbt.co/DcY6Gq",
                      <span className="qr-code-link">
                        https://hmbt.co/DcY6Gq
                      </span>,
                    )}
                  </p>
                ) : listgenUserID === "x100411" ? (
                  <p className="smaller-qr-code-text">
                    P.S. I am currently working with a qualified buyer looking
                    for a fixer in Hidden Valley. If you would consider an offer
                    on your home, please call me to discuss if your property
                    might be a fit for my client.
                    {qrHref(
                      "https://hmbt.co/DcY6Gq",
                      <span className="qr-code-link">
                        https://hmbt.co/DcY6Gq
                      </span>,
                    )}
                  </p>
                ) : (
                  <p>
                    {qrDescription}
                    <br /> or Go to
                    {qrHref(
                      homeOwnerURL,
                      <span className="qr-code-link">
                        OurProperty.info/{homeOwnerURLID}
                      </span>,
                    )}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default QRCode;
